import React, { ReactNode, FC, useContext, useRef, ReactElement } from "react";
import { Transition } from "react-transition-group";

import classnames from "classnames";

import { ItemContext, IItemContext } from "./AccordionItem";
import { StyledAccordionItemBody } from "./Styles";
import { useHeight } from "../../hooks/useHeight";

export interface IAccordionItemBody {
  /** Children type of node or string */
  children: ReactNode | string;
  /** ClassName */
  className?: string;
}

export const AccordionItemBody: FC<IAccordionItemBody> = ({
  children,
  className,
}) => {
  const itemContext = useContext<IItemContext | null>(ItemContext);
  const divRef = useRef(null);
  const duration = 200;
  const height = useHeight(divRef);

  const defaultStyle = {
    transition: `max-height ${duration}ms linear`,
    maxHeight: 0,
  };

  const transitionStyles = {
    entering: { maxHeight: height },
    entered: { maxHeight: height },
    exiting: { maxHeight: 0 },
    exited: { maxHeight: 0 },
  };

  return (
    <Transition timeout={200} in={itemContext?.isItemExpanded}>
      {(state): ReactElement => (
        <StyledAccordionItemBody
          ref={divRef}
          className={classnames("accordionItemBody", className)}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
          }}
        >
          {children}
        </StyledAccordionItemBody>
      )}
    </Transition>
  );
};

AccordionItemBody.displayName = "AccordionItemBody";
